import { PICKUP_ACTIONS, STATE_FOR_API_ERROR } from './constants';

export const uspsPickupReducer = (state, action) => {
  switch (action.type) {
    case PICKUP_ACTIONS.GET_API_DATA:
      return { ...action.payload };

    case PICKUP_ACTIONS.ON_API_ERROR:
      return STATE_FOR_API_ERROR;

    case PICKUP_ACTIONS.INPUT_CHANGE:
      return {
        ...state,
        futurePickup: {
          ...state.futurePickup,
          [action.payload.key]: action.payload.updatedValue,
        },
      };

    case PICKUP_ACTIONS.DROPDOWN_CHANGE:
      return {
        ...state,
        futurePickup: {
          ...state.futurePickup,
          [action.payload.key]: action.payload.location,
        },
      };
    default:
      return state;
  }
};
